module.exports = __webpack_public_path__ + "img/interactive-hero-slider-nissan.ae09c257.png";